import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const TermsOfService = () => {
  const { t } = useTranslation('common');

  const renderContent = (text) => {
    if (!text) return null;
    return text.split('\n').map((para, idx) => (
      <p key={idx} className="mb-2">{para}</p>
    ));
  };

  const sections = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <>
      <Helmet>
        <title>{t('termsOfService.title')} | Hotel Macarios</title>
        <meta name="description" content={t('termsOfService.intro')} />
        <link rel="canonical" href="https://www.hotelmacarios.com.mx/terms-of-service" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">{t('termsOfService.title')}</h1>
        <p className="text-gray-500 mb-8">{t('termsOfService.effectiveDate')}</p>

        <div className="text-gray-700 space-y-6">
          <p>{t('termsOfService.intro')}</p>

          {sections.map(num => {
            const titleKey = `termsOfService.section${num}.title`;
            const contentKey = `termsOfService.section${num}.content`;
            const title = t(titleKey);
            const content = t(contentKey);

            if (!content || content === contentKey) return null;

            return (
              <div key={num}>
                <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">{title}</h2>
                {renderContent(content)}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default TermsOfService;